import React, { useContext, useState, useEffect } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import { useForm } from 'react-hook-form';
import OwnershipContactCategoryForm from 'src/models/OwnershipContactCategoryForm';
import useFetch from 'use-http';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import Card from 'src/components/common/Card.redesign';
import CardContainer from 'src/components/common/CardContainer.redesign';
import './ContractContactCategoryDialog.scss';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { AnyObject } from 'final-form';
import LeaseGenerationOwnerData from 'src/models/leasing/LeaseGenerationOwnerData';
import OwnershipContactCategory from 'src/models/OwnershipContactCategory';
import Ownership from 'src/models/tract_detail/Ownership';
import IContract from 'src/models/contract_types/IContract';
import ContractGenerationOwnerData from './redesign/ContractGenerationModels/ContractGenerationOwnerData';
// import { DialogContext, dialogCreators } from 'src/providers/DialogProvider';
// import { useDispatch } from 'react-redux';

interface ICommittedContractProps {
    contactCategory: OwnershipContactCategoryForm;
    ownerData: LeaseGenerationOwnerData | ContractGenerationOwnerData;
    contractData: IContract;
    commitListener: (data: boolean) => void;
    hideDialog: () => void;
}

function ContractContactCategoryDialog(props: ICommittedContractProps) {
    const { handleSubmit, register } = useForm();
    const { response, post, get } = useFetch();
    // const dispatch = useDispatch();
    // const dialogContext = useContext<dialogCreators>(DialogContext);

    const appContext = useContext<IAppContextState>(AppContext);

    const [contactCategories, setContactCategories] = useState<OwnershipContactCategoryForm>(undefined);

    const [selectedCardId, setSelectedCardId] = useState<number>(undefined);
    const [disableCard, setDisableCard] = useState<boolean>(undefined);
    const [commitCategories, setCommitCategories] = useState<OwnershipContactCategory[]>(undefined);

    useEffect(() => {
        getContactCategories();
    }, []);

    useEffect(() => {
        committedLeaseCategories();
    }, [contactCategories]);

    const getContactCategories = async () => {
        let result = await get(`/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/ownershipContactCategories/form`);

        if (response.ok) {
            setContactCategories(result);
        } else {
            console.log('Unable to get Contact Categories!!');
        }
    };

    const handleCardClick = (index: number) => {
        if (index === selectedCardId) {
            setSelectedCardId((prevState) => {
                return (prevState = undefined);
            });
            setDisableCard((prevState) => !prevState);
        } else {
            setSelectedCardId(index);
            setDisableCard(true);
        }
    };

    const renderContactCards = () => {
        return !!commitCategories ? (
            commitCategories?.map((c, index) => {
                let cardClass = selectedCardId === index ? 'selected' : '';
                let disableFlag = cardClass === 'selected' ? false : disableCard;
                return (
                    <Card
                        key={index}
                        className={`small-input ${cardClass}`}
                        onClick={() => handleCardClick(index)}
                        style={!!disableFlag ? { pointerEvents: 'none', backgroundColor: '#a9a9a9', margin: '1rem' } : { margin: '1rem' }}
                    >
                        <div style={{ textAlign: 'center' }}>
                            <p style={{ paddingBottom: '1rem' }}>{c?.name}</p>
                            {cardClass === 'selected' && !disableFlag && (
                                <input type="text" name={`ownershipContactCategoryId`} hidden={true} defaultValue={c?.id} ref={register} />
                            )}
                        </div>
                    </Card>
                );
            })
        ) : (
            <div>No Categories Available!</div>
        );
    };

    const committedLeaseCategories = () => {
        // TODO: Find a better way to store these without hard-coding their values.
        let committedCategoriesIds: number[] = [2, 3, 4, 5];
        let actualCategories: OwnershipContactCategory[] = [];

        committedCategoriesIds.forEach((cci) => {
            let category = !!contactCategories ? contactCategories?.categories?.find((cc) => cc.id === cci) : undefined;
            actualCategories.push(category);
        });

        setCommitCategories(actualCategories);
    };

    const updateContactCategory = async (category: OwnershipContactCategory) => {
        let categories: OwnershipContactCategoryForm = {
            categories: [],
            addCategories: [],
            deleteCategories: [],
            updateCategories: [],
        };
        let newCategory: OwnershipContactCategory = category;

        categories.categories = contactCategories ? contactCategories?.categories : [];

        newCategory.isCrossProjectChecked = true;

        categories.updateCategories.push(newCategory);

        let result = await post(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/ownershipContactCategories`,
            categories
        );

        if (response.ok) {
            console.log('Succesfully update the contact categories', result);
            setTimeout(() => updateOwnerData(newCategory), 1500);
        } else {
            console.log('Error occurred while updated the contact categories!!');
        }
    };

    const updateOwnerData = (category: OwnershipContactCategory) => {
        let newOwnerObj: AnyObject = props?.ownerData ? props?.ownerData : null;
        let ownerships = 'ownerships';
        let leaseOwnershipList = props?.contractData?.tracts?.filter(t => t.includeTract === true);

        for (let leaseOwnership of leaseOwnershipList) {
            let updateOwnershipId = newOwnerObj[ownerships].findIndex((o: AnyObject) => o.id === leaseOwnership.ownershipId);
            let tractIndex = newOwnerObj.tracts.findIndex((t: AnyObject) => t.ownershipId === leaseOwnership.ownershipId);
    
            let sectionNumber: number = newOwnerObj.tracts[tractIndex].sectionNumber;
    
            let updateOwnership: Ownership = {
                id: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].id : null,
                ownerLookUpId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].ownerLookUpId : null,
                horizonId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].horizonId : null,
                ownershipType: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].ownershipType : '',
                decimalInterest: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].decimalInterest : null,
                executiveRights: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].executiveRights : null,
                isLeased: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].isLeased : false,
                parentOwnershipId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].parentOwnershipId : null,
                leaseBuyer: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].leaseBuyer : '',
                contactCategory: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].contactCategory : '',
                ownershipContactCategoryId: !!category ? category?.id : null,
                leasedStatus: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].leasedStatus : '',
                additionalOwnershipTypeId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].additionalOwnershipTypeId : null,
                additionalOwnerships: props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].additionalOwnerships : [],
                note: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].note : '',
                isWIClientAcreage: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].isWIClientAcreage : null,
            };
    
            updateOwnershipDetail(updateOwnership, sectionNumber);
        }
        if (leaseOwnershipList.length === 0 && ownerships?.length > 0) {
            const updateOwnershipId = 0;
            const updateOwnership: Ownership = {
                id: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].id : null,
                ownerLookUpId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].ownerLookUpId : null,
                horizonId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].horizonId : null,
                ownershipType: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].ownershipType : '',
                decimalInterest: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].decimalInterest : null,
                executiveRights: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].executiveRights : null,
                isLeased: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].isLeased : false,
                parentOwnershipId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].parentOwnershipId : null,
                leaseBuyer: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].leaseBuyer : '',
                contactCategory: category.name,
                ownershipContactCategoryId: category.id,
                leasedStatus: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].leasedStatus : '',
                additionalOwnershipTypeId: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].additionalOwnershipTypeId : null,
                additionalOwnerships: props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].additionalOwnerships : [],
                note: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].note : '',
                isWIClientAcreage: !!props?.ownerData ? newOwnerObj[ownerships][updateOwnershipId].isWIClientAcreage : null,
            };
            updateOwnershipDetail(updateOwnership, 0);
        }
    };

    const updateOwnershipDetail = async (ownershipDetail: Ownership, sectionNumber: number) => {
        let result = await post(
            `/v1.0/clients/${appContext.clientNumber}/projects/${appContext.projectNumber}/fields/${sectionNumber}/tracts/save-ownership-detail`,
            ownershipDetail
        );

        if (response.ok) {
            console.log('Successfully update the contact category!!', result);
            props.hideDialog();
        } else {
            console.log('Error while trying to update the contact categroy of the owner!!');
        }
    };

    const onSubmit = (data: AnyObject) => {
        let contactCategoryId = data?.ownershipContactCategoryId ? parseInt(data?.ownershipContactCategoryId + '', 10) : undefined;

        let correctContactCategory = !!contactCategories && contactCategories?.categories?.find((c) => c.id === contactCategoryId);

        let alreadySavedCategory = !!props?.contactCategory?.categories?.find((c) => c.id === contactCategoryId) ? true : false;

        if (!!correctContactCategory && !alreadySavedCategory) {
            props.commitListener(true);
            updateContactCategory(correctContactCategory);
        }

        if (!!contactCategoryId && alreadySavedCategory) {
            props.commitListener(true);
            updateOwnerData(correctContactCategory);
        }
    };

    return (
        <Dialog title="Lease - Committed Status">
            <form onSubmit={handleSubmit(onSubmit)}>
                <CardContainer>{renderContactCards()}</CardContainer>
                <div style={{ margin: '2rem 0 0 1rem' }}>
                    <Button text="Save Category" type="submit" intent="primary" />
                </div>
            </form>
        </Dialog>
    );
}

export default ContractContactCategoryDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/ContractContactCategoryDialog.tsx